import type { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import { CustomTable } from 'components/table/style';
import { Badge, Spinner, Table, Typography } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { AddItemModal } from 'modules/dashboard/components/AddItemModal';
import type { Trainer } from 'modules/trainers/core/type';

import { checkRole } from 'helpers';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const TrainerComp: FC<{
  trainerColumns: any[];
  trainers: Trainer[];
  totalTrainer: number;
  listTrainer: Trainer[];
  membersColumns: any[];
  handleUpdateMembers: (type: 'trainer' | 'learner') => void;
  searchTrainer: string;
  onChangeSearchTrainer: (event: React.ChangeEvent<HTMLInputElement>) => void;
  showNoDataTrainer: boolean;
  hasMore: boolean;
  handleLoadMoreTrainer: () => void;
}> = ({
  trainerColumns,
  trainers,
  totalTrainer,
  listTrainer,
  membersColumns,
  handleUpdateMembers,
  searchTrainer,
  onChangeSearchTrainer,
  showNoDataTrainer,
  hasMore,
  handleLoadMoreTrainer,
}) => {
  const isTrainer = checkRole([RoleKey.TRAINER_BIOLOGIC, RoleKey.TRAINER_INSTITUTION]);

  return (
    <div>
      <CustomTable className="pb-0">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingBottom: 16,
            // borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-25']}`,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Typography
              weight={500}
              color={COLOR.surfaceNeutralBold['neutral-11']}
              style={{ fontSize: 22, lineHeight: '30px' }}
            >
              Trainers
            </Typography>

            <Badge
              bg={COLOR_CONFIG['neutral-text']}
              color="#ffffff"
              count={totalTrainer}
              style={{ fontWeight: 600, fontSize: 14, lineHeight: '20px' }}
            />
          </div>

          {!isTrainer && (
            <AddItemModal
              title={' Add trainer'}
              extraDropdownContentStyle={{ position: 'absolute', right: 0 }}
              options={listTrainer}
              onAdd={() => handleUpdateMembers('trainer')}
              placeholderSearch="Search by name or email"
              searchValue={searchTrainer}
              onChange={onChangeSearchTrainer}
              content={
                <div style={{ height: '100%', overflow: 'auto' }}>
                  <InfiniteScroll
                    pageStart={1}
                    loadMore={handleLoadMoreTrainer}
                    hasMore={hasMore}
                    loader={
                      <div style={{ color: '#262626', textAlign: 'center' }} key={0}>
                        <Spinner style={{ margin: '8px 0' }} size={'md'} />
                      </div>
                    }
                    useWindow={false}
                  >
                    <Table
                      columns={membersColumns}
                      dataSource={listTrainer}
                      total={99999}
                      tableKey={''}
                      queryState={{
                        page: 1,
                        limit: 99999,
                      }}
                      paginationConfigs={{
                        show: false,
                      }}
                      headerConfigs={{
                        show: false,
                      }}
                    />
                  </InfiniteScroll>
                </div>
              }
            />
          )}
        </div>
        {showNoDataTrainer ? (
          <Typography
            variant="h4"
            weight={600}
            style={{
              textAlign: 'center',
              justifyContent: 'center',
              marginTop: 16,
              marginBottom: 40,
            }}
          >
            No data
          </Typography>
        ) : (
          <Table
            columns={trainerColumns}
            dataSource={trainers}
            total={99999}
            tableKey={''}
            queryState={{ page: 1, limit: 999999 }}
            paginationConfigs={{
              show: false,
            }}
          />
        )}
      </CustomTable>
    </div>
  );
};
